const lang = {
    actionButton: {
        confirm: 'OK',
        cancel: 'Batal',
    },
};
export default lang;
